import axios from 'axios';

const requestTimeout = Number(process.env.VUE_APP_API_TIMEOUT || 20000);
// const requestQuotationBaseUrl = (process.env.VUE_APP_REQUEST_QOUTATION_BASE_URL || '').replace(/\/+$/, '');
const requestQuotationBaseUrl = process.env.VUE_APP_REQUEST_QOUTATION_BASE_URL;


const isRequestQuotationRequest = (url = '') => {
	if (!requestQuotationBaseUrl || !url) return false;

	const normalizedUrl = String(url);
	return normalizedUrl.replace(/\/+$/, '').startsWith(requestQuotationBaseUrl);
};

const instance = axios.create({
	baseURL: process.env.VUE_APP_API_BASE_URL,
	timeout: requestTimeout,
	withCredentials: true,
	headers: {
		'Content-Type': 'application/json',
		'Accept': 'application/json',
		'X-Requested-With': 'XMLHttpRequest',
	}
});

instance.interceptors.request.use(
	config => {
		const excludePaths = ['/', '/login', '/create-account', '/forgot-password']
		let is_excluded = excludePaths.includes(window.location.pathname);

		if (isRequestQuotationRequest(config.url)) {
			if (config.headers?.Authorization) {
				delete config.headers.Authorization;
			}
			return config;
		}

		if(!is_excluded){
			const userStateString = localStorage.getItem('user_state');
			const userState = JSON.parse(userStateString);
			const jwtToken = userState ? userState.jwtToken : null;
			if (jwtToken) {
				config.headers.Authorization = `Bearer ${jwtToken}`;
				return config;
			} else {
				return Promise.reject('Unauthorized');
			}
		}else{
			return config;
		}
	},
	error => {
		return Promise.reject(error);
	}
);

export default instance;
